'use strict';

var Class      = require('../util/class'),
    Deferrable = require('../mixins/deferrable');

module.exports = Class(Deferrable);



//////////////////
// WEBPACK FOOTER
// ./~/faye/src/protocol/publication.js
// module id = 299
// module chunks = 0